import React from 'react';

const hints = [
  "Discover hidden gems off the beaten path.",
  "A perfect trip combines adventure and relaxation.",
  "Try local cuisine wherever you go.",
  "Capture the sunrise at least once during your travels.",
  "Engage with locals for authentic experiences.",
  "Every journey tells a story, make yours unforgettable.",
  "Pack light, travel far.",
  "Explore the world beyond your comfort zone.",
  "Nature walks can reveal the best-kept secrets.",
  "Plan a trip that sparks joy every day.",
  "Meet your desire for adventure."
];

const PawLoader = () => {
  const randomHint = hints[Math.floor(Math.random() * hints.length)];

  return (
    <div style={{display:'flex', flexDirection:'column', alignItems:'center',position:'relative',zIndex: '1000000000000', justifyContent:'center', height:'100vh', background:'#fff'}}>
      <div style={{width:'100px', height:'100px', animation:'pulse 1.5s infinite', position:'relative'}}>
        <div style={{width:'50px', height:'50px', background:'#0d3b2e', borderRadius:'50%', position:'absolute', bottom:0, left:'50%', transform:'translateX(-50%)'}}></div>
        <div style={{width:'20px', height:'20px', background:'#0d3b2e', borderRadius:'50%', position:'absolute', top:0, left:'12px'}}></div>
        <div style={{width:'20px', height:'20px', background:'#0d3b2e', borderRadius:'50%', position:'absolute', top:-4, left:'40px'}}></div>
        <div style={{width:'20px', height:'20px', background:'#0d3b2e', borderRadius:'50%', position:'absolute', top:-4, right:'40px'}}></div>
        <div style={{width:'20px', height:'20px', background:'#0d3b2e', borderRadius:'50%', position:'absolute', top:0, right:'12px'}}></div>
      </div>
      <p style={{
        marginTop: '24px',
          color: '#0d3b2e',
          fontWeight: '500',
          fontFamily: "'Segoe UI', sans-serif",
          textAlign: 'center',
          padding: '0 10px'
      }}>{randomHint}</p>
      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.8; }
        }
      `}</style>
    </div>
  );
};

export default PawLoader;
